<template>
  <v-card class="left-vertical-card">
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        {{ titreModale }}
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div
      v-if="parametre == null && hasFormulaireOuiNon"
      class="d-flex flex-column mx-4"
    >
      <AgrialSwitch
        v-model="isFormulaireOuiNon"
        label-on="Formulaire Oui / Non"
        label-off="Formulaire par défaut"
      />
    </div>
    <div
      v-if="parametre == null || (parametre != null && parametre.typeRubrique != null && parametre.typeRubrique.libelleSousRubrique != null && parametre.typeRubrique.statut !== 'OBLIGATOIRE' && parametre.typeRubrique.statut !== 'FACULTATIF')"
      class="d-flex flex-column mx-4"
      :class="hasFormulaireOuiNon ? '' : 'mt-4'"
    >
      <AgrialInput
        v-model="libelle"
        :label="isFormulaireOuiNon ? 'Nom (Ex: Biostim, défanage) *' : 'Nom *'"
        hide-details
      />
    </div>

    <div
      v-if="!isFormulaireOuiNon && parametre != null && parametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS'"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialSelect
        v-model="parametreModifiable.unite"
        :items="unites"
        item-text="libelle"
        :label="`Unité ${parametre && parametre.typeRubrique.statut === 'OBLIGATOIRE' ? '*' : ''}`"
        hide-details
      />
    </div>
    <div
      v-if="!isFormulaireOuiNon && !isAideCouplee && (parametre== null || (parametre!= null && !parametre.typeRubrique.isValeurEconomiqueUniquement))"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.valeurMin"
        :label="`${libelleMin} ${parametre && parametre.typeRubrique.statut === 'OBLIGATOIRE' ? '*' : ''}`"
        :suffix="`${parametreModifiable.unite ? parametreModifiable.unite : unite}`"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div
      v-if="!isFormulaireOuiNon && (parametre== null || (parametre!= null && !parametre.typeRubrique.isValeurEconomiqueUniquement))"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.valeurDefaut"
        :label="`${libelleDefaut}  ${parametre && parametre.typeRubrique.statut === 'OBLIGATOIRE' ? '*' : ''}`"
        :suffix="`${parametreModifiable.unite ? parametreModifiable.unite : unite}`"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div
      v-if="!isFormulaireOuiNon && !isAideCouplee && (parametre== null || (parametre!= null && !parametre.typeRubrique.isValeurEconomiqueUniquement))"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.valeurMax"
        :label="`${libelleMax}  ${parametre && parametre.typeRubrique.statut === 'OBLIGATOIRE' ? '*' : ''}`"
        :suffix="`${parametreModifiable.unite ? parametreModifiable.unite : unite}`"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div
      v-if="(isFormulaireOuiNon && parametre == null) || (parametre!= null && (parametre.typeRubrique.isValeurEconomiqueUniquement || parametre.typeRubrique.isValeurEconomiqueObligatoire))"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialInputNumber
        v-model.number="parametreModifiable.valeurEconomique"
        :label="isFormulaireOuiNon ? 'Coût *' : 'Coût sur valeur par défaut *'"
        suffix="€/ha"
        :rules="[rules.positif]"
        min="0"
      />
    </div>
    <div
      v-if="isRubriqueTraitement && !isFormulaireOuiNon && (parametre== null || (parametre!= null && !parametre.typeRubrique.isValeurEconomiqueUniquement))"
      class="d-flex flex-column mt-6 mx-4"
    >
      <AgrialSelect
        v-model="pressionValeurDefaut"
        :items="pressionsFiltrees"
        label="Pression par défaut"
        hide-details
      />
    </div>
    <div
      v-if="parametre && parametre.typeRubrique.statut === 'OBLIGATOIRE'"
      class="my-2 ml-5 action texte-gris-fonce"
    >
      * Champs obligatoires
    </div>
    <BaseMessage
      v-if="parametreModifiable.valeurDefaut === null && (parametre == null && parametre.typeRubrique.statut !== 'OBLIGATOIRE')"
      class="mx-5 mt-3"
      color="warning"
      :message="`Sans valeur par défaut, le champ ${parametre.typeRubrique.libelleSousRubrique} ne sera pas affiché à l'utilisateur`"
      text
      type="warning"
    />

    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        color="primary darken-1"
        :disabled="!isValid"
        @click="save()"
      >
        Valider
      </AgrButton>
    </v-card-actions>
    <v-snackbar
      v-if="erreur"
      v-model="erreur"
      class="top-snackbar"
      top
      right
      timeout="5000"
      color="red"
    >
      <v-icon
        color="white"
        class="mr-3"
      >
        mdi-alert-circle
      </v-icon>
      <span class="action white--text"> {{ erreur }} </span>
    </v-snackbar>
  </v-card>
</template>
<script>
import { AgrButton } from '@agrial/ui'
import AgrialInputNumber from '@/components/form/agrial-input-number.vue'
import AgrialInput from '@/components/form/agrial-input.vue'
import AgrialSelect from '@/components/form/agrial-select.vue'
import AgrialSwitch from '@/components/form/agrial-switch.vue'
import BaseMessage from '@/components/common/base-message.vue'
import { mapActions, mapGetters } from 'vuex'
import {clone} from '@/utils/clone'
import { isEmptyString } from '@/utils/string'

export default {
  name: 'UpdateParametreModal',
  components: {AgrButton, AgrialInput, AgrialInputNumber, AgrialSelect, AgrialSwitch, BaseMessage},
  props: {
    parametre: {
      type: Object,
      default: null
    },
    isAideCouplee: {
      type: Boolean,
      default: false
    },
    unite: {
      type: String,
      default: null
    },
    isRubriqueEngrais: {
      type: Boolean,
      default: false
    },
    isRubriqueTraitement: {
      type: Boolean,
      default: false
    },
    typeCulture: {
      type: Object,
      default: () => {}
    },
    typeRubrique: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      isEmptyString: isEmptyString,
      libelle: null,
      isFormulaireOuiNon: false,
      parametreModifiable: {typeRubrique: {}, typeCulture: {}},
      erreur: null,
      pressionValeurDefaut: null,
      rules: {
        positif: value => (value != null && value >= 0) || 'Doit être >= 0',
      }
    }
  },

  computed: {
    ...mapGetters({
      unites: 'comparateurMarge/unites'
    }),
    hasFormulaireOuiNon () {
      return this.isRubriqueEngrais || this.isRubriqueTraitement
    },
    titreModale () {
      let nomChamp = 'Nouveau paramètre'
      if (this.parametre != null && this.parametre.typeRubrique != null) {
        nomChamp = this.parametre.typeRubrique.libelleSousRubrique
        if (this.isMaisGrainOuSorgo && this.parametre.typeRubrique.libelleSousRubrique === 'Rendement') {
          nomChamp = 'Rendement sec'
        }
        if (this.isMaisGrainOuSorgo && this.parametre.typeRubrique.libelleSousRubrique === 'Prix de vente') {
          nomChamp = 'Prix net de frais de séchage'
        }
        if (this.parametre.typeRubrique.codeRubrique === 'DENSITE_SEMIS') {
          nomChamp = 'Densité de semis'
        }
      }
      return this.parametre != null ? 'Modification - ' + nomChamp : 'Nouveau paramètre'
    },
    libelleMin () {
      return this.isRubriqueTraitement ? 'Coût (pression faible)' : 'Valeur min'
    },
    libelleDefaut () {
      return this.isRubriqueTraitement ? 'Coût (pression moyenne)' : 'Valeur défaut'
    },
    libelleMax () {
      return this.isRubriqueTraitement ? 'Coût (pression forte)' : 'Valeur max'
    },
    pressionsFiltrees () {
      let result = []
      if (this.parametreModifiable.valeurMin != null) {
        result.push('Pression faible')
      }
      if (this.parametreModifiable.valeurDefaut != null) {
        result.push('Pression moyenne')
      }
      if (this.parametreModifiable.valeurMax != null) {
        result.push('Pression forte')
      }
      return result
    },
    isValid () {
      if (this.parametre != null && this.parametre.typeRubrique.statut === 'OBLIGATOIRE') {
        let islibelleValid = (this.parametre.typeRubrique.libelleSousRubrique != null && this.libelle != null && !this.isEmptyString(this.libelle)) || (this.parametre.typeRubrique.libelleSousRubrique == null && this.parametreModifiable.unite != null)
        let isValeurMinValid = this.isAideCouplee || (this.parametreModifiable.valeurMin != null && this.parametreModifiable.valeurMin >= 0)
        let isValeurMaxValid = this.isAideCouplee || (this.parametreModifiable.valeurMax != null && this.parametreModifiable.valeurMax >= 0)
        let isValeurDefautValid = this.parametreModifiable.valeurDefaut != null && this.parametreModifiable.valeurDefaut >= 0
        let isValeurEcoValid = !this.parametre.typeRubrique.isValeurEconomiqueObligatoire || (this.parametre.typeRubrique.isValeurEconomiqueObligatoire && this.parametreModifiable.valeurEconomique!= null && this.parametreModifiable.valeurEconomique >= 0)
        return isValeurMinValid && isValeurMaxValid && isValeurDefautValid && isValeurEcoValid && islibelleValid
      }
      if (this.isRubriqueTraitement && !this.isFormulaireOuiNon && (this.parametre == null || (this.parametre!= null && !this.parametre.typeRubrique.isValeurEconomiqueUniquement && this.parametre.typeRubrique.statut !== 'OBLIGATOIRE'))) {
        return this.pressionValeurDefaut != null
      }
      return this.libelle != null && !this.isEmptyString(this.libelle)
        && ((this.isFormulaireOuiNon && this.parametreModifiable.valeurEconomique != null && this.parametreModifiable.valeurEconomique >= 0) || !this.isFormulaireOuiNon)
    },
    isMaisGrainOuSorgo () {
      return this.parametre && this.parametre.typeCulture && (this.parametre.typeCulture.code === 'MG' || this.parametre.typeCulture.code === 'SGG')
    }
  },

  created () {
    this.getAdminComparateurMargeUnites()
    this.parametreModifiable = this.parametre != null ? clone(this.parametre) : {}
    this.pressionValeurDefaut = this.parametreModifiable.pressionValeurDefaut
    this.libelle = this.parametre != null && this.parametre.typeRubrique != null ? this.parametre.typeRubrique.libelleSousRubrique : null
  },

  methods: {
    ...mapActions({
      getAdminComparateurMargeUnites: 'comparateurMarge/getAdminComparateurMargeUnites',
      createOrUpdateAdminComparateurParametreMarge: 'comparateurMarge/createOrUpdateAdminComparateurParametreMarge'
     }),
    
    onClose () {
      this.$emit('close')
    },
    save () {
      if (this.parametreModifiable.id != null && this.libelle) {
        this.parametreModifiable.typeRubrique.libelleSousRubrique = this.libelle
      }
      if (this.parametreModifiable.id == null) {
        this.parametreModifiable.typeCulture = this.typeCulture
        this.parametreModifiable.typeRubrique = { codeRubrique: this.typeRubrique.codeRubrique, libelleSousRubrique: this.libelle, isValeurEconomiqueUniquement: this.isFormulaireOuiNon}
      }
      if (this.typeRubrique && this.typeRubrique.codeRubrique === 'TRAITEMENT' && this.pressionValeurDefaut) {
        this.parametreModifiable.pressionValeurDefaut = this.pressionValeurDefaut
      }
      this.createOrUpdateAdminComparateurParametreMarge(this.parametreModifiable)
        .then(() => this.$emit('updatedParametre'))
        .catch((error) => this.erreur = error.response.data.message)
    }
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>